module.exports = __webpack_public_path__ + "img/7-on.ccf08096.png";